import React, { FC, useEffect, useRef, useState } from "react";
import { Add, ArrowForwardIos, Delete } from "@mui/icons-material";
import { FaEdit } from "react-icons/fa";
import { Button } from "../../components/ui";
import { useDispatch, useSelector } from "react-redux";
import {
  resetAddesRules,
  setAddRuleForSelectedParam,
  setAddRulePanelStatus,
  setOpenIndex,
  setParameterMode,
  setRuleMode,
  setSelectedParameter,
  setSelectedRuleIndex,
  udpateAddParameterData,
} from "../../reducers/riskEngineSlice";
import { TAllParametersRulesObj } from "../../types/eiskEngine";
import { TRootState } from "../../store";

interface Rule {
  id: number;
  condition: string;
  result: string;
}

interface AccordionItem {
  id: number;
  title: string;
  weight: number;
  description?: string;
  rules: Rule[];
}

interface Props {
  items: TAllParametersRulesObj[];
  onClickDeleteParameter: any;
  onClickDeleteRule: any;
  onClickEditParameter: any;
}

const ParameterCustomAccordion: FC<Props> = ({
  items,
  onClickDeleteParameter,
  onClickDeleteRule,
  onClickEditParameter,
}) => {
  const dispatch = useDispatch();

  const { addParameterRuleData, ruleMode, openIndex } = useSelector(
    (state: TRootState) => ({
      addParameterRuleData: state.riskEngineDetailsSlice.addParameterRuleData,
      ruleMode: state.riskEngineDetailsSlice.ruleMode,
      openIndex: state.riskEngineDetailsSlice.openIndex,
    })
  );
  const [openIndexes, setOpenIndexes] = useState<number[]>([]);
  const [heights, setHeights] = useState<string[]>([]);
  const contentRefs = useRef<(HTMLDivElement | null)[]>([]);

  const toggleItem = (index: number) => {
    setOpenIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  // Handle dynamic height animation
  useEffect(() => {
    const newHeights = items.map((_, index) => {
      if (openIndexes.includes(index) && contentRefs.current[index]) {
        return contentRefs.current[index]!.scrollHeight + "px";
      }
      return "0px";
    });

    setHeights(newHeights);
  }, [openIndexes, items]);
  // useEffect(() => {
  //   if (items.length > 0) {
  //     setOpenIndexes([0]);
  //   }
  // }, [items]);

  const handleAddRule = (id: number) => {
    const newRule = {
      temp_id: Date.now(),
      rule_id: 0,
      rule_name: "",
      score: 0,
      status: 1,
    };

    const updatedRules = [newRule];

    dispatch(
      udpateAddParameterData({
        addParameterRuleData: {
          ...addParameterRuleData,
          param_id: id,
          rules: updatedRules,
        },
      })
    );

    dispatch(setOpenIndex([newRule.temp_id]));
  };

  return (
    <div className="flex flex-col gap-4">
      {items.map((item, index) => {
        const open = openIndexes.includes(index);

        return (
          <div
            key={item.param_id}
            className="border  rounded-[10px] overflow-hidden"
          >
            <div
              onClick={() => {
                toggleItem(index);
                dispatch(setAddRuleForSelectedParam(item));
              }}
              className="flex justify-between items-center bg-oceangreen px-2 py-2 cursor-pointer"
            >
              <div className="flex items-center gap-3">
                <div
                  style={{
                    transition: "transform 0.3s ease",
                    transform: open ? "rotate(90deg)" : "rotate(0deg)",
                  }}
                >
                  <ArrowForwardIos style={{ fontSize: 16 }} />
                </div>

                <span className="text-lg font-medium fs-14">
                  {item.param_name}
                </span>

                <span className="border-primary bg-white px-3 py-1 rounded-md text-sm color-primary">
                  Weight: {item.weight}
                </span>
              </div>

              <div className="flex items-center gap-2">
                <div
                  className="flex gap-1 color-primary"
                  style={{ fontSize: "15px" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    onClickEditParameter(item);
                    dispatch(setOpenIndex([]));
                    dispatch(setSelectedRuleIndex(0));
                  }}
                >
                  <span className="text-lg">
                    <FaEdit />
                  </span>
                  Edit
                </div>
                <span
                  className="cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    onClickDeleteParameter(item);
                  }}
                >
                  <div className="ml-2 bg-light-red  p-2 rounded-full color-red cursor-pointer flex items-center justify-center  w-[30px] h-[30px]">
                    <Delete style={{ fontSize: 16 }} />
                  </div>
                </span>
              </div>
            </div>

            <div
              ref={(el) => (contentRefs.current[index] = el)}
              style={{
                maxHeight: heights[index] || "0px",
                overflow: "hidden",
                transition: "max-height 0.4s ease, opacity 0.3s ease",
                opacity: open ? 1 : 0,
              }}
              className="bg-white"
            >
              <div className="card_space_18">
                <div className="flex justify-between items-center mb-2">
                  <span className="fs-14 color-sub-text font-bold">
                    Rules ({item.rules.length})
                  </span>
                  <Button
                    variant="outlined-primary"
                    onClick={() => {
                      dispatch(setOpenIndex([]));
                      handleAddRule(item.param_id);
                      dispatch(setAddRulePanelStatus(true));
                      dispatch(setSelectedParameter(item));
                      dispatch(setAddRuleForSelectedParam(item));
                      dispatch(setRuleMode("add"));
                      dispatch(setSelectedRuleIndex(-1));
                      dispatch(setParameterMode(""));
                    }}
                  >
                    <Add className="color-primary" /> Add Rule
                  </Button>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  {item.rules.map((rule) => (
                    <div
                      key={rule.rule_id}
                      className="bg-gray-bg rounded-[10px] p-3 flex justify-between items-center"
                    >
                      <div className="fs-14 color-sub-text flex gap-1 flex-col">
                        <p>{rule.rule_name}</p>
                      </div>

                      <div className="flex gap-2 items-center">
                        <div
                          className="color-primary cursor-pointer"
                          onClick={() => {
                            dispatch(setAddRulePanelStatus(true));
                            dispatch(setSelectedParameter(item));
                            dispatch(setAddRuleForSelectedParam(item));
                            dispatch(
                              setSelectedRuleIndex(
                                rule.rule_id! || rule.temp_id!
                              )
                            );
                            dispatch(setOpenIndex([]));
                            dispatch(setRuleMode("edit"));
                          }}
                        >
                          {" "}
                          <FaEdit style={{ fontSize: 16 }} />
                        </div>
                        <div
                          className="ml-2 bg-light-red  p-2 rounded-full color-red cursor-pointer flex items-center justify-center  w-[30px] h-[30px]"
                          onClick={() => {
                            dispatch(setAddRulePanelStatus(true));
                            dispatch(setSelectedParameter(item));
                            dispatch(setAddRuleForSelectedParam(item));
                            dispatch(
                              setSelectedRuleIndex(
                                rule.rule_id! || rule.temp_id!
                              )
                            );
                            dispatch(setRuleMode("delete"));
                            dispatch(setOpenIndex([]));
                          }}
                        >
                          <Delete style={{ fontSize: 16 }} />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ParameterCustomAccordion;
